/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Weight_LongInputs */

const en_us2_intake_why_weight_long = /** @type {(inputs: Intake_Why_Weight_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first week's loads are a fraction of body weight. It goes into your series so you can see it move.`)
};

const pt_br2_intake_why_weight_long = /** @type {(inputs: Intake_Why_Weight_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As cargas da primeira semana são uma fração do peso corporal. Vai para a sua série para você ver mudar.`)
};

const es_419_intake_why_weight_long = /** @type {(inputs: Intake_Why_Weight_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las cargas de la primera semana son una fracción del peso corporal. Se guarda en tu historial para que lo veas cambiar.`)
};

const pt_pt2_intake_why_weight_long = /** @type {(inputs: Intake_Why_Weight_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As cargas da primeira semana são uma fração do peso corporal. Fica registado na tua série para o veres mudar.`)
};

const fr_fr2_intake_why_weight_long = /** @type {(inputs: Intake_Why_Weight_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les charges de la première semaine sont une fraction du poids du corps. Il rejoint ta courbe pour que tu le voies évoluer.`)
};

const de_de2_intake_why_weight_long = /** @type {(inputs: Intake_Why_Weight_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Gewichte der ersten Woche sind ein Bruchteil deines Körpergewichts. Es kommt in deinen Verlauf, damit du siehst, wie es sich ändert.`)
};

const it_it2_intake_why_weight_long = /** @type {(inputs: Intake_Why_Weight_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I carichi della prima settimana sono una frazione del peso corporeo. Finisce nel tuo storico, così lo vedi cambiare.`)
};

/**
* | output |
* | --- |
* | "The first week's loads are a fraction of body weight. It goes into your series so you can see it move." |
*
* @param {Intake_Why_Weight_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_weight_long = /** @type {((inputs?: Intake_Why_Weight_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Weight_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_weight_long(inputs)
	if (locale === "es-419") return es_419_intake_why_weight_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_weight_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_weight_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_weight_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_weight_long(inputs)
	return en_us2_intake_why_weight_long(inputs)
});
export { intake_why_weight_long as "intake.why.weight.long" }